import React, { useState } from 'react';
import { Form, Button, InputGroup, Badge } from 'react-bootstrap';
import { FaSearch, FaFilter, FaMapMarkedAlt, FaBuilding } from 'react-icons/fa';
import './Filter.css';

const Filter = ({ filter, companyNames, count, darkMode }) => {
  const [expanded, setExpanded] = useState(false);
  const [filters, setFilters] = useState([
    true,   // TODOS
    false,  // LOCAÇÃO
    false,  // SIMT
    false,  // BIMT
    false,  // CPMT
    false,  // EEMT
    false,  // ESMR
    false,  // ESTADOS
    false,  // CIDADES
    false,  // ONLINE
    false,  // 999DRY
    false   // CNMT
  ]);
  const [company, setCompany] = useState('');
  const [serial, setSerial] = useState('');

  const handleFilterChange = (index) => {
    const newFilters = [...filters];
    
    // Lógica para lidar com filtros exclusivos
    if (index === 0) { // TODOS
      newFilters[0] = !newFilters[0];
      // Se TODOS for marcado, desmarque os outros
      if (newFilters[0]) {
        for (let i = 1; i < newFilters.length; i++) {
          if (i !== 7 && i !== 8) newFilters[i] = false; // Mantém ESTADOS e CIDADES
        }
      }
    } else if (index === 7 || index === 8) { // ESTADOS ou CIDADES
      // São mutuamente exclusivos
      if (index === 7) newFilters[8] = false;
      if (index === 8) newFilters[7] = false;
      newFilters[index] = !newFilters[index];
    } else {
      // Quando qualquer outro filtro é marcado, desmarca TODOS
      if (newFilters[index]) {
        newFilters[index] = false;
      } else {
        newFilters[0] = false;
        newFilters[index] = true;
      }
    }
    
    setFilters(newFilters);
    filter(newFilters, company, serial);
  };

  const handleCompanyChange = (e) => {
    setCompany(e.target.value);
    filter(filters, e.target.value, serial);
  };

  const handleSerialChange = (e) => {
    setSerial(e.target.value);
    filter(filters, company, e.target.value);
  };

  const clearFilters = () => {
    setFilters([true, false, false, false, false, false, false, false, false, false, false, false]);
    setCompany('');
    setSerial('');
    filter([true, false, false, false, false, false, false, false, false, false, false, false], '', '');
  };

  return (
    <div className={`map-filter-wrapper ${darkMode ? 'dark' : 'light'}`}>
      <div className="map-filter-container">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center">
            <FaFilter className="me-2" />
            <h5 className="m-0">Filtros</h5>
          </div>
          <div>
            <Badge bg={darkMode ? "light" : "secondary"} text={darkMode ? "dark" : "light"} className="map-count-badge">
              {count} equipamentos
            </Badge>
            <Button 
              variant={darkMode ? "outline-light" : "outline-secondary"} 
              size="sm" 
              className="ms-2"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Recolher' : 'Expandir'}
            </Button>
          </div>
        </div>

        {/* Filtro Rápido - Sempre visível */}
        <div className="quick-filters mb-3">
          <div className="d-flex flex-wrap gap-2">
            <Button 
              size="sm" 
              variant={filters[0] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
              onClick={() => handleFilterChange(0)}
              className="filter-button"
            >
              TODOS
            </Button>
            <Button 
              size="sm" 
              variant={filters[9] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
              onClick={() => handleFilterChange(9)}
              className="filter-button"
            >
              ONLINE
            </Button>
            <Button 
              size="sm" 
              variant={filters[1] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
              onClick={() => handleFilterChange(1)}
              className="filter-button"
            >
              LOCAÇÃO
            </Button>
            <Button 
              size="sm" 
              variant={filters[7] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
              onClick={() => handleFilterChange(7)}
              className="filter-button"
            >
              <FaMapMarkedAlt className="me-1" />
              ESTADOS
            </Button>
            <Button 
              size="sm" 
              variant={filters[8] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
              onClick={() => handleFilterChange(8)}
              className="filter-button"
            >
              <FaMapMarkedAlt className="me-1" />
              CIDADES
            </Button>
            <Button 
              size="sm" 
              variant="outline-danger"
              onClick={clearFilters}
              className="filter-button ms-auto"
            >
              Limpar
            </Button>
          </div>
        </div>

        {/* Filtros expandidos */}
        {expanded && (
          <div className="expanded-filters">
            <div className="row mb-3">
              <div className="col-md-6">
                <h6 className="filter-section-title">Tipo de Equipamento</h6>
                <div className="d-flex flex-wrap gap-2">
                  <Button 
                    size="sm" 
                    variant={filters[2] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(2)}
                    className="filter-button"
                  >
                    SIMT
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[3] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(3)}
                    className="filter-button"
                  >
                    BIMT
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[4] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(4)}
                    className="filter-button"
                  >
                    CPMT
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[5] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(5)}
                    className="filter-button"
                  >
                    EEMT
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[6] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(6)}
                    className="filter-button"
                  >
                    ESMR
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[10] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(10)}
                    className="filter-button"
                  >
                    999DRY
                  </Button>
                  <Button 
                    size="sm" 
                    variant={filters[11] ? "success" : darkMode ? "outline-light" : "outline-secondary"}
                    onClick={() => handleFilterChange(11)}
                    className="filter-button"
                  >
                    CNMT
                  </Button>
                </div>
              </div>
              
              <div className="col-md-6">
                <h6 className="filter-section-title">Empresa</h6>
                <Form.Group>
                  <InputGroup>
                    <InputGroup.Text><FaBuilding /></InputGroup.Text>
                    <Form.Select
                      value={company}
                      onChange={handleCompanyChange}
                      className="map-form-control"
                    >
                      <option value="">Todas as empresas</option>
                      {companyNames?.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            
            <div className="row">
              <div className="col-12">
                <h6 className="filter-section-title">Buscar por Número de Série</h6>
                <InputGroup>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                  <Form.Control
                    placeholder="Digite o número de série"
                    value={serial}
                    onChange={handleSerialChange}
                    className="map-form-control"
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
